import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { DEFAULT_MARKS } from '../../../components/Messenger/constants/defaultMarks';

export const addMark = createAsyncThunk(
  'messenger/addMark',
  async (data, { signal, rejectWithValue, getState }) => {
    try {
      const source = axios.CancelToken.source();
      signal.addEventListener('abort', () => {
        source.cancel();
      });

      try {
        // TODO: replace with api call (return updated filter list)
        const filterList = [
          {
            name: DEFAULT_MARKS.ALL,
            count: getState().messenger.conversations.length,
          },
          {
            name: data.name,
            count: 1,
          },
        ];

        return Promise.resolve(filterList);
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const addMarkExtraReducers = builder => {
  builder
    .addCase(addMark.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.newMark.request,
        action,
        action.meta.arg.name,
      );
    })
    .addCase(addMark.fulfilled, (state, action) => {
      onMatchedRequest(
        state.newMark.request[action.meta.arg.name],
        action,
        () => {
          state.filters.list = action.payload;
        },
      );
    })
    .addCase(addMark.rejected, (state, action) => {
      handleRequestRejection(
        state.newMark.request[action.meta.arg.name],
        action,
      );
    });
};
